import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputLabel,
  Box,
  MenuItem,
  Select,
  useTheme,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
  Checkbox,
  FormGroup,
  TextField,
  Backdrop,
} from "@mui/material";
import { BankOutlined, TeamOutlined } from "@ant-design/icons";
import { useFormik } from "formik";
import { inject, observer } from "mobx-react";
import {
  Tooltip,
  Upload,
  message,
  Tag,
  Input,
  InputNumber,
  Col,
  Table,
} from "antd";
import RichEditor from "../../components/RichEditor/RichEditor";

import * as Yup from "yup";
import {
  AiFillBank,
  AiOutlineDelete,
  AiOutlineFolder,
  AiOutlineUpload,
  AiOutlineUser,
} from "react-icons/ai";
import { User } from "iconoir-react";
import {
  ASSIGNEE_TYPE,
  DATE_FORMAT_SLASH,
  MODES,
  PROPOSAL_STATUS,
  SHIFTS,
  TYPE_STATUS,
} from "../../utils/constants";
import SelectPeoplePopup from "../../components/SelectPeoplePopup/SelectPeoplePopup";
import { AvatarHasName } from "../../components/common/Avatar";
import "../../components/RichEditor/RichEditor.scss";
import { MyUploadAdapter } from "./../../components/RichEditor/MyUploadAdapter";
import { useNavigate } from "react-router-dom";
import PopupRenameFile from "../../components/PopupRenameFile/PopupRenameFile";
import utils from "../../utils";
import moment from "moment";

import { Inputs } from "../../components/input/inputStyled";
import { toJS } from "mobx";
import { StatusTag } from "../../components/common/StatusTag";
import FileItem from "../../components/FileItemComponent/FileItem";
import { getExtensionFile } from "../../utils/common";
import { DeleteOutlined } from "@mui/icons-material";
import CircularProgress from "@mui/material/CircularProgress";
import { SelectList } from "../InternalDocumentIncoming/InternalDocumentIncomingDocCreatePageStyled";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";
import "dayjs/locale/vi"; // Import ngôn ngữ tiếng Việt cho dayjs
import Message from "../../components/common/Message";
dayjs.locale("vi"); // Đặt ngôn ngữ mặc định cho dayjs

const toolbar = [
  "insertTable",
  "Alignment",
  "Autoformat",
  "AutoLink",
  "BlockQuote",
  "Bold",
  "Essentials",
  "FontBackgroundColor",
  "FontColor",
  "FontFamily",
  "FontSize",
  "Heading",
  "Image",
  "ImageInsert",
  "ImageResize",
  "ImageStyle",
  "ImageToolbar",
  "ImageUpload",
  "Indent",
  "IndentBlock",
  "Italic",
  "Link",
  "List",
  "ListStyle",
  "MediaEmbed",
  "MediaEmbedToolbar",
  "Mention",
  "Paragraph",
  "PasteFromOffice",
  "Strikethrough",
  "Table",
  "TableCellProperties",
  "TableProperties",
  "TableToolbar",
  "TextTransformation",
  "TodoList",
  "Underline",
  "WordCount",
];

const UpdateProposal = (props) => {
  let {
    params,
    open,
    code,
    handleClose,
    selectPeopleStore,
    fileStore,
    proposalStore,
    authenticationStore,
    otherDetail,
    count,
    setCount,
    proposalTypeName,
    proposalType,
  } = props;

  const { proposalApproveConfig, items, content, formProposalType } =
    proposalStore;
  // console.log('otherDetail', toJS(otherDetail))
  // console.log('items', toJS(items))
  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    originDepartmentWithUserList,
  } = selectPeopleStore;

  const EDITOR_REF = useRef();
  const [editorState, setEditorState] = useState(null);
  // const [proposalType, setProposalType] = useState("");
  const [keyForm, setKeyForm] = useState("");
  const theme = useTheme();
  const [approvalLevels, setApprovalLevels] = useState([]);
  const [isVisibleSelectUserPopup, setIsVisibleSelectUserPopup] =
    useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [userNextStep, setUserNextStep] = useState();
  const [warningMessage, setWarningMessage] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const [originFiles, setOriginFiles] = useState([]);
  const [fileExt, setFileExt] = useState(undefined);
  const [fileTargetRename, setFileTargetRename] = useState(null);
  const [fileFromDocumentList, setFileFromDocumentList] = useState([]);
  const [handlerList, setHandlerList] = useState([]);
  const [followerList, setFollowerList] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [data, setData] = useState("");
  const [isModalVisibleRenameFile, setIsModalVisibleRenameFile] =
    useState(false);
  const [fieldsRenameFile, setFieldsRenameFile] = useState([
    {
      name: ["rename"],
      value: "",
    },
  ]);
  const [isRenameFileUpdate, setIsRenameFileUpdate] = useState(false);
  const [reasonForLeaving, setReasonForLeaving] = useState("");
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [typeOfLeave, setTypeOfLeave] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const ASSIGNEE_TYPE_CONFIG = [
    ASSIGNEE_TYPE.CREATE,
    ASSIGNEE_TYPE.COMBINER,
    ASSIGNEE_TYPE.HANDLER,
    ASSIGNEE_TYPE.LEADER,
  ];

  // Nếu có người theo dõi thì SelectPeoplePopup của người theo dõi sẽ được chọn nhiều người
  const [checkFollower, setCheckFollower] = useState(true);
  // List step
  let approvalLevelList = proposalApproveConfig.approvalLevels || [];
  // Lấy curentUser để gán vào list step
  useEffect(() => {
    const approvalLevelList = [
      ...proposalStore.proposalApproveConfig.approvalLevels,
    ];
    if (approvalLevelList.length === 0) {
      setApprovalLevels([]);
      return;
    }
    approvalLevelList[0].username = authenticationStore.currentUser?.username;
    setApprovalLevels(approvalLevelList);
  }, [proposalStore.proposalApproveConfig, authenticationStore.currentUser]);

  useEffect(() => {
    if (editorState) {
      const editor = editorState;
      editor.plugins.get("FileRepository").createUploadAdapter = function (
        loader
      ) {
        return new MyUploadAdapter(loader);
      };

      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );

      editor.editing.view.change((writer) => {
        writer.setStyle(
          "height",
          "200px",
          editor.editing.view.document.getRoot()
        );
      });
    }
  }, [editorState]);

  useEffect(() => {
    if (!otherDetail.id) return;

    // form.setFieldsValue({
    //   title: otherDetail.title,
    //   // proposal_type: PROPOSAL_TYPE[otherDetail.proposal_type].label,
    // })

    // setEditorContent(otherDetail.reason)
    // contentTemplateStore.content = null
    proposalStore.setFormProposalType(otherDetail.proposal_type);

    setOriginFiles(otherDetail.attachments);
    (async () => {
      await proposalStore.getProposalTypeApprovalConfig(
        otherDetail.proposal_type
      );
    })();

    let followerLists = [];

    otherDetail?.followers.forEach((follower) => {
      if (follower?.user_name) {
        followerLists.push({
          assignee_type: ASSIGNEE_TYPE.USER,
          full_name: follower.name_lowercase.toUpperCase(),
          id: follower.user_name,
          image_id: follower.image_id,
          permission: ASSIGNEE_TYPE.FOLLOWER,
        });
      }
    });

    if (followerLists.length > 0) {
      selectPeopleStore.setSelectUserData({
        ...selectUserData,
        [ASSIGNEE_TYPE.FOLLOWER]: followerLists,
      });
    }

    return () => {
      selectPeopleStore.clearSelectUserData(ASSIGNEE_TYPE.FOLLOWER);
    };
  }, [count]);

  // lấy danh sách người theo dõi
  useEffect(() => {
    setFollowerList([
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ]);
  }, [selectUserData, selectDepartmentData, selectGroupData]);

  // thay đổi tên file- tài liệu đính kèm
  const updateAttachments = useCallback(async () => {
    const uploadFileList = fileList.map((file) => file.originFileObj);
    const batchUploadArr = [];
    uploadFileList.forEach((file) => {
      const formData = new FormData();
      formData.append("file", file);
      batchUploadArr.push(fileStore.uploadFile(formData));
    });
    const response = await Promise.all(batchUploadArr);
    const res = response
      .map((response) => response.data.file_id)
      .concat(fileFromDocumentList.map((file) => file.file_id));
    // formik.setFieldValue('file_ids', res)
  }, [fileList, fileFromDocumentList]);

  useEffect(() => {
    updateAttachments();
    formik.setFieldValue("parent_id", code);
  }, [updateAttachments]);

  useEffect(() => {
    formik.setFieldValue("reason", content);
  }, [content]);

  const navigate = useNavigate();
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: otherDetail?.title.trim(),
      proposal_type: "",
      reason: otherDetail?.reason,
      from_date: otherDetail?.from_date,
      to_date: otherDetail?.to_date,
      reason_for_leaving: otherDetail?.reason_for_leaving,
      type_of_leave: otherDetail?.type_of_leave,
      overtime: otherDetail?.overtime,
    },
    validationSchema: Yup.object({
      title: Yup.string().trim().required("Vui lòng nhập tiêu đề !!!"),
      from_date: Yup.string().required("Vui lòng chọn thời gian bắt đầu."),
      to_date: Yup.string().required("Vui lòng chọn thời gian kết thúc."),
    }),
    onSubmit: async (values) => {
      // if (!userNextStep) {
      //   setWarningMessage(`Hãy chọn Cấp duyệt!`)
      //   return
      // }
      const uploadFileList = fileList
        ? fileList.map((file) => file.originFileObj)
        : [];
      const batchUploadArr = [];

      uploadFileList.forEach((file) => {
        const formData = new FormData();
        formData.append("file", file);
        batchUploadArr.push(fileStore.uploadFile(formData));
      });

      const response = await Promise.all(batchUploadArr);

      const originFileList = (otherDetail.attachments || []).map(
        (file) => file.file_id
      );
      const afterFileList = [
        ...response.map((el) => el.data.file_id),
        ...originFiles.map((file) => file.file_id),
      ];

      let newAttachments = [];
      let removeAttachments = [];

      afterFileList.forEach((file) => {
        if (!originFileList.includes(file)) {
          newAttachments.push(file);
        }
      });
      originFileList.forEach((file) => {
        if (!afterFileList.includes(file)) {
          removeAttachments.push(file);
        }
      });

      const removeFollowers = otherDetail?.followers.filter((follower) => {
        if (!followerList.some((item) => item.id === follower.user_name)) {
          return follower;
        }
      });

      const newFollowers = followerList.filter((follower) => {
        if (
          !otherDetail?.followers.some((item) => item.user_name === follower.id)
        ) {
          return follower;
        }
      });
      let proposal = {
        ...values,
        code: otherDetail?.proposal_code,
        title: values.title.trim(),
        proposal_type: otherDetail?.proposal_type,
        attachments: {
          remove_items: removeAttachments,
          new_items: newAttachments,
        },
        assignees: {
          remove_items: removeFollowers.map((follower) => ({
            assignee_code: follower.user_name,
            assignee_type: "USER",
            permission: "VIEW",
          })),
          new_items: newFollowers.map((follower) => ({
            assignee_code: follower.id,
            assignee_type: "USER",
            permission: "VIEW",
          })),
        },
        reason: EDITOR_REF.current.editor.getData(),
        proposalTimeList,
      };
      try {
        setIsLoading(true);
        await proposalStore.updateProposal(proposal);
        await proposalStore.getOtherDetail(otherDetail?.proposal_code);
        message.success("Cập nhật thành công!");
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
        close();
      }
    },
  });

  const close = () => {
    formik.resetForm();
    setCount(count + 1);
    setData("");
    // selectPeopleStore.clearSelected();
    setFileList([]);
    setHandlerList([]);
    setFollowerList([]);
    handleClose();

    return navigate(`/proposal/view/${otherDetail?.proposal_code}`);
  };

  const handleOpenPopupRenameFile = (file, index) => {
    setFieldsRenameFile([
      {
        name: ["rename"],
        value: utils.removeExtensionFile(file.name),
      },
    ]);
    setFileExt("." + utils.getExtensionFile(file.name));
    setFileTargetRename({
      ...file,
      index: index,
    });
    setIsModalVisibleRenameFile(true);
  };

  const handleFileChange = useCallback(async (info) => {
    const filteredFileList = info.fileList.filter(
      (elem, index, fileArray) =>
        fileArray.findIndex((file) => file.name === elem.name) === index
    );
    setFileList(filteredFileList);
  }, []);
  const handleRemoveFileFromDocumentList = (file_id) => {
    const newFileList = fileFromDocumentList.filter(
      (file) => file.file_id !== file_id
    );
    setFileFromDocumentList(newFileList);
  };
  const handleRemoveFileFromUploadList = (fileUID) => {
    const newFileList = fileList.filter((file) => file.uid !== fileUID);
    setFileList(newFileList);
  };
  const renameFile = (originalFile, newName) => {
    return new File([originalFile], newName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    });
  };
  const submitRenameFile = async (value) => {
    const index = fileTargetRename?.index;
    // đổi tên file nhận từ thiết bị (file chưa ký)
    if (fileTargetRename.originFileObj) {
      const newFileList = [...fileList];
      newFileList[index].name = value.rename + fileExt;
      newFileList[index].originFileObj = renameFile(
        newFileList[index].originFileObj,
        newFileList[index].name
      );
      setFileList(newFileList);
      setIsModalVisibleRenameFile(false);
      // message.success('Đổi tên file thành công')
    }
    // đổi tên file nhận từ thiết bị (file đã ký)
    if (!fileTargetRename.originFileObj) {
      await fileStore.handleRenameFile(
        fileTargetRename.id,
        value.rename + fileExt
      );
      setIsModalVisibleRenameFile(false);
      const newFileList = [...fileList];
      newFileList[index].name = value.rename + fileExt;
      setFileList(newFileList);
      message.success("Đổi tên file thành công");
    }
  };

  const getInfoUser = (username, departmentWithUserList) => {
    const user = {
      full_name: username,
      image_id: null,
      username: username,
    };
    departmentWithUserList.forEach((department) => {
      const userTarget = department.users.find(
        (user) => user.user_name === username
      );
      if (userTarget) {
        user.full_name = userTarget.name_uppercase || username;
        user.image_id = userTarget.image_id;
      }
    });
    return user;
  };

  useEffect(() => {
    const approvalLevelsUpdate = approvalLevels.map((item) => {
      if (!item.allow_edit) {
        return item;
      }
      const assignTypeIndex = approvalLevels
        .filter((el) => el.allow_edit)
        .findIndex((el) => el.level === item.level);
      const getUser = (index) => {
        if (![0, 1, 2, 3].includes(index)) {
          return {};
        }
        return selectUserData[ASSIGNEE_TYPE_CONFIG[index]].length > 0
          ? selectUserData[ASSIGNEE_TYPE_CONFIG[index]][0]
          : {};
      };
      return {
        ...item,
        username: getUser(assignTypeIndex).id,
        user: {
          full_name: getUser(assignTypeIndex).full_name,
          image_id: getUser(assignTypeIndex).image_id,
          username: getUser(assignTypeIndex).id,
        },
      };
    });
    setApprovalLevels(approvalLevelsUpdate);
  }, [selectUserData]);

  const handleChangeStyle = (event) => {
    // setProposalType(event.target.value);
    proposalStore.getProposalTypeApprovalConfig(event.target.value);
    proposalStore.setFormProposalType(event.target.value);
  };

  const listForm = items.map((item, index) => (
    <MenuItem key={index} value={item.key}>
      {item.label}
    </MenuItem>
  ));

  // lấy list biểu mẫu
  useEffect(() => {
    proposalStore.load();

    return () => {
      proposalStore.clear();
    };
  }, []);

  const handleChangeForm = (event) => {
    proposalStore.getDetails(event.target.value);
    setKeyForm(event.target.value);
  };

  const handleOpenSelectUser = (level) => {
    let userType = null;
    if (level === ASSIGNEE_TYPE.FOLLOWER) {
      userType = level;
      setCheckFollower(false);
    } else {
      setCheckFollower(true);
    }
    const levelAllowEditList = proposalApproveConfig.approvalLevels?.filter(
      (item) => item.allow_edit
    );
    const indexLevelAllowEdit = levelAllowEditList.findIndex(
      (item) => item.level === level
    );
    if (indexLevelAllowEdit !== -1) {
      userType = ASSIGNEE_TYPE_CONFIG[indexLevelAllowEdit];
    }
    if (userType) {
      selectPeopleStore.setAssigneePopupType(userType);
      setIsVisibleSelectUserPopup(true);
    } else {
      return message.warning("Không rõ chọn người loại nào!");
    }
  };

  const handleSubmitSelectUser = useCallback(() => {
    setIsVisibleSelectUserPopup(false);
  }, []);
  // Chữ cái đầu viết hoa
  const capitalizeFirstLetter = (name) => {
    return name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  // sự kiện chọn Lý do
  const handleChangeReasonForLeaving = (event) => {
    formik.handleChange({
      target: {
        name: "reason_for_leaving",
        value: event.target.value,
      },
    });
  };

  // sự kiện chọn Loại nghỉ phép
  const handleChangeTypeForLeaving = (event) => {
    formik.handleChange({
      target: {
        name: "type_of_leave",
        value: event.target.value,
      },
    });
  };

  // sự kiện active input Thêm giờ làm việc
  const handleCheckboxChange = (event) => {
    setIsCheckboxChecked(event.target.checked);
  };
  const [messages, setMessage] = useState("");
  const [openMessage, setOpenMessage] = useState(false);
  const [severity, setSeverity] = useState("");
  const createMessage = (messages, openMessage, severity) => {
    setMessage(messages);
    setOpenMessage(openMessage);
    setSeverity(severity);
  };
  const onChangeEndAt = (endAt) => {
    const startDate = moment(formik.values.from_date).format("DD/MM/YYYY");
    const endDate = moment(endAt.$d).format("DD/MM/YYYY");
    if (
      moment(endDate, "DD/MM/YYYY").isSameOrAfter(
        moment(startDate, "DD/MM/YYYY")
      )
    ) {
      formik.handleChange({
        target: {
          name: "to_date",
          value: moment(endAt.$d).format("YYYY-MM-DD"),
        },
      });
    } else {
      createMessage(
        "thời gian kết thúc không thể sớm hơn thời gian bắt đầu, xin vui lòng chọn lại !!!",
        true,
        "error"
      );
    }
  };
  const onChangeStartAt = (startAt) => {
    const endDate = moment(formik.values.to_date).format("DD/MM/YYYY");
    const startDate = moment(startAt.$d).format("DD/MM/YYYY");
    if (
      moment(endDate, "DD/MM/YYYY").isSameOrAfter(
        moment(startDate, "DD/MM/YYYY")
      )
    ) {
      formik.handleChange({
        target: {
          name: "from_date",
          value: moment(startAt.$d).format("YYYY-MM-DD"),
        },
      });
    } else {
      createMessage(
        "thời gian bắt đầu không thể muộn hơn thời gian kết thúc, xin vui lòng chọn lại !!!",
        true,
        "error"
      );
    }
  };

  const [selectedDates, setSelectedDates] = useState([
    dayjs(formik.values.from_date).startOf("day").format(DATE_FORMAT_SLASH),
    dayjs(formik.values.to_date).startOf("day").format(DATE_FORMAT_SLASH),
  ]);
  const [proposalTimeList, setProposalTimeList] = useState(
    otherDetail?.proposalTimeList || []
  );

  const handleShiftChange = (value, recordId) => {
    const updatedWorkDays = proposalTimeList.map(day =>
      day.id === recordId ? { ...day, shift: value } : day
    );
    setProposalTimeList(updatedWorkDays);
  };

  const handleModeChange = (value, recordId) => {
    let modeTypeValue = 0;

    if (value === MODES.WOMEN.key) {
      modeTypeValue = 1;
    } else if (value === MODES.CHILD_CARE.key) {
      modeTypeValue = 0.5;
    }
    const updatedWorkDays = proposalTimeList.map(day =>
      day.id === recordId
        ? { ...day, mode: value, mode_type: modeTypeValue }
        : day
    );
    setProposalTimeList(updatedWorkDays);
  };

  const handleModeTypeChange = (value, recordKey) => {
    const updatedWorkDays = proposalTimeList.map(day =>
      day.id === recordKey ? { ...day, mode_type: value } : day
    );
    setProposalTimeList(updatedWorkDays);
  };

  const handleNoteChange = (value, recordKey) => {
    const updatedWorkDays = proposalTimeList.map(day =>
      day.id === recordKey ? { ...day, note: value } : day
    );
    setProposalTimeList(updatedWorkDays);
  };

  const handleDateChange = (date, index) => {
    const newDateRange = [...selectedDates];
    newDateRange[index] = dayjs(date).startOf("day").format(DATE_FORMAT_SLASH);
    setSelectedDates(newDateRange);
  };

  // Trả về mảng của các ngày trong khoảng startDate đến endDate
  function getRange(startDate, endDate) {
    let fromDate = moment(startDate, "DD/MM/YYYY");
    let toDate = moment(endDate, "DD/MM/YYYY");
    let diff = toDate.diff(fromDate, "days");
    let range = [];

    for (let i = 0; i <= diff; i++) {
      let currentDay = moment(startDate, "DD/MM/YYYY").add(i, "days");
      if (proposalType === "OVERTIME_NORMAL") {
        range.push(currentDay);
      } else {
        if (currentDay.day() !== 6 && currentDay.day() !== 0) {
          range.push(currentDay);
        }
      }
    }

    return range;
  }

  const generateWorkDays = () => {
    const workDays = [];
    const dateRange = getRange(selectedDates[0], selectedDates[1]);
    if (dateRange?.length > 0) {
      dateRange.forEach((date, index) => {
        const formattedDate = date;

        const existingDay = otherDetail?.proposalTimeList?.find(
          day =>
            moment(day.date).format("DD/MM/YYYY") ===
            moment(formattedDate).format("DD/MM/YYYY")
        );

        if (existingDay) {
          workDays.push({ ...existingDay });
        } else {
          if (proposalType === "LEAVE_ABNORMAL") {
            workDays.push({
              id: index,
              date: formattedDate,
              shift: "morning",
              mode: "normal",
              mode_type: 0,
              note: null,
            });
          } else {
            workDays.push({
              id: index,
              date: formattedDate,
              shift: "allDay",
              mode: "normal",
              note: null,
            });
          }
        }
      });
      setProposalTimeList(workDays);
    } else {
      setProposalTimeList([]);
    }
  };

  useEffect(() => {
    selectedDates?.length > 0 && generateWorkDays();
  }, [selectedDates]);

  const columns = [
    {
      title: "Ngày làm việc",
      dataIndex: "date",
      key: "date",
      render: text => <span>{moment(text).format("DD/MM/YYYY")}</span>,
      // fixed: 'left',
    },
    {
      title: "Buổi làm việc",
      dataIndex: "shift",
      key: "shift",
      render: (text, record) => (
        <Select
          style={{
            width: "120px",
          }}
          value={text}
          onChange={value => handleShiftChange(value.target.value, record.id)}
          size="small"
        >
          <MenuItem value={SHIFTS.ALL_DAY.key}>{SHIFTS.ALL_DAY.value}</MenuItem>
          <MenuItem value={SHIFTS.MORNING.key}>{SHIFTS.MORNING.value}</MenuItem>
          <MenuItem value={SHIFTS.AFTERNOON.key}>
            {SHIFTS.AFTERNOON.value}
          </MenuItem>
          <MenuItem value={SHIFTS.EMPTY.key}>{SHIFTS.EMPTY.value}</MenuItem>
        </Select>
      ),
    },
    ...(proposalType !== "BUSINESS_TRIP" && proposalType !== "OVERTIME_NORMAL"
      ? [
          {
            title: "Loại nghỉ phép",
            dataIndex: "mode",
            key: "mode",
            render: (text, record) => (
              <Select
                style={{
                  width: "120px",
                }}
                value={text}
                size="small"
                onChange={value =>
                  handleModeChange(value.target.value, record.id)
                }
              >
                <MenuItem value={MODES.NORMAL.key}>
                  {MODES.NORMAL.value}
                </MenuItem>
                <MenuItem value={MODES.SPECIAL.key}>
                  {MODES.SPECIAL.value}
                </MenuItem>
              </Select>
            ),
          },
        ]
      : []),
    ...(proposalType === "OVERTIME_NORMAL"
      ? [
          {
            title: "Giờ",
            dataIndex: "mode_type",
            key: "mode_type",
            width: "160px",
            render: (text, record) => {
              return (
                <InputNumber
                  style={{ width: "90px" }}
                  defaultValue={record.mode_type}
                  min={0}
                  max={8}
                  onChange={value => handleModeTypeChange(value, record.id)}
                />
              );
            },
          },
        ]
      : []),
    {
      title: "Ghi chú",
      dataIndex: "note",
      key: "note",
      render: (text, record) => (
        <Input
          defaultValue={text}
          onChange={e => handleNoteChange(e.target.value, record.id)}
          placeholder="Nhập ghi chú"
        />
      ),
    },
  ];

  const leaveAbnormalColumns = [
    {
      title: "Ngày làm việc",
      dataIndex: "date",
      key: "date",
      render: text => <span>{moment(text).format("DD/MM/YYYY")}</span>,
      // fixed: 'left',
    },
    {
      title: "Buổi làm việc",
      dataIndex: "shift",
      key: "shift",
      render: (text, record) => (
        <Select
          style={{
            width: "120px",
          }}
          value={text}
          size="small"
          onChange={value => handleShiftChange(value.target.value, record.id)}
        >
          <MenuItem value={SHIFTS.MORNING.key}>{SHIFTS.MORNING.value}</MenuItem>
          <MenuItem value={SHIFTS.AFTERNOON.key}>
            {SHIFTS.AFTERNOON.value}
          </MenuItem>
          <MenuItem value={SHIFTS.EMPTY.key}>{SHIFTS.EMPTY.value}</MenuItem>
        </Select>
      ),
    },
    {
      title: "Loại nghỉ phép",
      dataIndex: "mode",
      key: "mode",
      render: (text, record) => (
        <Select
          style={{
            width: "160px",
          }}
          value={text}
          size="small"
          onChange={value => handleModeChange(value.target.value, record.id)}
        >
          <MenuItem value={MODES.NORMAL.key}>{MODES.NORMAL.value}</MenuItem>
          <MenuItem value={MODES.WOMEN.key}>{MODES.WOMEN.value}</MenuItem>
          <MenuItem value={MODES.CHILD_CARE.key}>
            {MODES.CHILD_CARE.value}
          </MenuItem>
          <MenuItem value={MODES.WORK_REASON.key}>
            {MODES.WORK_REASON.value}
          </MenuItem>
          <MenuItem value={MODES.BY_REGIME.key}>
            {MODES.BY_REGIME.value}
          </MenuItem>
        </Select>
      ),
    },
    {
      title: "Loại chế độ (giờ)",
      dataIndex: "mode_type",
      key: "mode_type",
      width: "160px",
      render: (text, record) => {
        switch (record.mode) {
          case MODES.NORMAL.key:
          case MODES.WORK_REASON.key:
          case MODES.BY_REGIME.key:
            return (
              <InputNumber
                style={{ width: "90px" }}
                defaultValue={record.mode_type}
                min={0}
                max={8}
                onChange={value => handleModeTypeChange(value, record.id)}
              />
            );
          case MODES.WOMEN.key:
            return <span>{record.mode_type}</span>;
          case MODES.CHILD_CARE.key:
            return <span>{record.mode_type}</span>;
          default:
            return null;
        }
      },
    },
    {
      title: "Ghi chú",
      dataIndex: "note",
      key: "note",
      with: "250px",
      render: (text, record) => (
        <Input
          defaultValue={text}
          onChange={e => handleNoteChange(e.target.value, record.id)}
          placeholder="Nhập ghi chú"
        />
      ),
    },
  ];

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll={"paper"}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      className="doc-popup"
      fullWidth
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100vw",
            maxWidth: "100vw", // Set your width here
            mx: 0,
            zIndex: 50,
          },
        },
      }}
    >
      {/*  Tạo loading khi tạo mới*/}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle
          id="scroll-dialog-title"
          className="text-xl font-bold text-[#ffffff] "
          sx={{
            fontWeight: 700,
            backgroundColor: "#2C65AC",
          }}
        >
          <span className="font-bold">Chỉnh sửa hành chính</span>
        </DialogTitle>
        <DialogContent>
          <>
            <Box>
              <InputLabel style={{ marginTop: "20px", color: "#23374D" }}>
                <span className="text-red-500">*</span> Tiêu đề:
              </InputLabel>
              <Inputs
                name="title"
                value={formik.values.title}
                placeholder={"Nhập tiêu đề..."}
                onChange={formik.handleChange}
              />
              {formik.errors.title && formik.touched.title && (
                <p style={{ color: "red" }}>{formik.errors.title}</p>
              )}
            </Box>
            <Box style={{ marginBottom: "12px" }}>
              <InputLabel
                style={{
                  marginTop: "12px",
                  marginBottom: "5px",
                  color: "#23374D",
                }}
              >
                Loại:
              </InputLabel>

              <TextField
                className="bg-zinc-300 rounded-sm w-full"
                hiddenLabel
                name="overtime"
                defaultValue={proposalTypeName.name_child}
                disabled={true}
              />

              <InputLabel
                style={{
                  marginTop: "12px",
                  marginBottom: "5px",
                  color: "#23374D",
                }}
              >
                Nội dung:
              </InputLabel>
              <RichEditor
                EDITOR_REF={EDITOR_REF}
                placeholder={"Nhập nội dung..."}
                setData={setData}
                editorContent={content ?? otherDetail?.reason}
              />
            </Box>

            {otherDetail?.reason_for_leaving && (
              <Box xs={24} lg={24}>
                <label>Lý do:</label>
                <br />
                <FormControl>
                  <RadioGroup
                    name="reason_for_leaving"
                    onChange={handleChangeReasonForLeaving}
                    value={formik.values.reason_for_leaving}
                  >
                    <FormControlLabel
                      value={"Theo chế độ"}
                      control={<Radio />}
                      label="Theo chế độ"
                    />
                    <FormControlLabel
                      value={"Lý do cá nhân"}
                      control={<Radio />}
                      label="Lý do cá nhân"
                    />
                    <FormControlLabel
                      value={"Lý do công việc"}
                      control={<Radio />}
                      label="Lý do công việc"
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
            )}

            {otherDetail?.type_of_leave && (
              <Box xs={24} lg={24}>
                <FormControl>
                  <FormLabel
                    id="radio-buttons-group-label"
                    className="text-black "
                  >
                    <span className="text-red-500">*</span> Loại nghỉ phép:
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="type_of_leave"
                    value={formik.values.type_of_leave}
                    onChange={handleChangeTypeForLeaving}
                  >
                    <FormControlLabel
                      value="Nghỉ phép 1/2 ngày công"
                      control={<Radio />}
                      label="Nghỉ phép 1/2 ngày công"
                    />
                    <FormControlLabel
                      value="Nghỉ phép theo chế độ"
                      control={<Radio />}
                      label="Nghỉ phép theo chế độ"
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
            )}

            <Box xs={24} sm={12} md={10}>
              <p className="mt-3 mb-1">
                <span className="text-red-500">*</span> Ngày bắt đầu:
              </p>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <MobileDatePicker
                  name="from_date"
                  value={formik.values.from_date}
                  onChange={(startAt) => {
                    onChangeStartAt(startAt);
                    handleDateChange(startAt, 0);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      InputLabelProps={{ shrink: false }}
                      placeholder="Chọn ngày bắt đầu"
                      className="border-black"
                    />
                  )}
                />
                {formik.errors.from_date && formik.touched.from_date && (
                  <p style={{ color: "red" }}>{formik.errors.from_date}</p>
                )}
              </LocalizationProvider>
              <div className="mt-1 mb-5">
                <p className="mt-2 mb-1">
                  <span className="text-red-500">*</span> Ngày kết thúc:
                </p>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <MobileDatePicker
                    name="to_date"
                    value={formik.values.to_date}
                    onChange={(endAt) => {
                      onChangeEndAt(endAt);
                      handleDateChange(endAt, 1);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        InputLabelProps={{ shrink: false }}
                        placeholder="Chọn ngày kết thúc"
                        className="border-black"
                      />
                    )}
                  />
                  {formik.errors.to_date && formik.touched.to_date && (
                    <p style={{ color: "red" }}>{formik.errors.to_date}</p>
                  )}
                </LocalizationProvider>
              </div>
            </Box>

            <Box>
              {(proposalType === "LEAVE" ||
                proposalType === "BUSINESS_TRIP" ||
                proposalType === "RETIMEKEEPING" ||
                proposalType === "OVERTIME_NORMAL" ||
                proposalType === "LEAVE_ABNORMAL") &&
                proposalTimeList?.length > 0 && (
                  <Col xs={24} style={{ marginBottom: "25px" }}>
                    <Table
                      pagination={false}
                      columns={
                        proposalType === "LEAVE_ABNORMAL"
                          ? leaveAbnormalColumns
                          : columns
                      }
                      rowKey={record => record.key || record.id}
                      dataSource={proposalTimeList || []}
                      scroll={{
                        x: 800,
                      }}
                    />
                  </Col>
                )}
            </Box>

            <Box>
              {otherDetail?.overtime && (
                <>
                  <Box>
                    <label>Thêm số giờ làm việc:</label>
                    <Checkbox
                      style={{ marginLeft: "5px", paddingTop: "5px" }}
                      checked={isCheckboxChecked}
                      onChange={handleCheckboxChange}
                    ></Checkbox>
                    <br />
                    <TextField
                      hiddenLabel
                      id="filled-hidden-label-normal"
                      name="overtime"
                      value={formik.values.overtime}
                      onChange={formik.handleChange}
                      placeholder="Nhập số giờ dương <= 12"
                      disabled={!isCheckboxChecked}
                    />
                  </Box>
                </>
              )}
            </Box>

            <Box
              sx={{
                margin: "10px 0",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Upload
                valuePropName={"fileList"}
                fileList={fileList}
                multiple={true}
                onChange={handleFileChange}
                beforeUpload={() => false}
                showUploadList={false}
              >
                <Button variant="contained">
                  <AiOutlineUpload className="mr-2 -mt-1" />
                  Chọn tài liệu đính kèm
                </Button>
              </Upload>
            </Box>
            <div>
              {originFiles.map((file) => (
                <div
                  key={file.file_id}
                  className="flex justify-between pb-2 pt-4 border-b border-zinc-200"
                >
                  {/* 
                  tạm thời cmt
                  <FileItem
                    file={file}
                    key={file.file_id}
                    file_id={file.file_id}
                    file_name={file.file_name}
                    file_type={getExtensionFile(file.file_name)}
                  /> */}
                  <div className="flex items-center">
                    <AiOutlineFolder className="mr-1 ml-1 text-[#2C65AC]" />
                    <span style={{ color: "#1890FF" }}>{file.file_name}</span>
                  </div>
                  <span
                    onClick={() =>
                      setOriginFiles(
                        originFiles.filter((el) => el.file_id !== file.file_id)
                      )
                    }
                  >
                    <AiOutlineDelete className="text-red-500 ml-2 bg-[rgba(0,115,199,0.07);]" />
                  </span>
                </div>
              ))}
            </div>
            {fileFromDocumentList.length !== 0 && (
              <ul
                style={{
                  margin: "10px 0 0",
                  paddingLeft: "0 !important",
                  height: " auto !important",
                  overflow: "hidden !important",
                }}
              >
                {fileFromDocumentList.map((file) => (
                  <li
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: "8px",
                      transition: "all ease 0.3s",
                      padding: "3px 0",
                      borderBottom: " 1px solid #ebebeb",
                      color: "#2C65AC",
                    }}
                    key={file.file_id}
                  >
                    <div className="flex items-center">
                      <AiOutlineFolder className="mr-1 ml-1" />
                      <span
                        onClick={() =>
                          fileStore.handleDownloadFile(
                            file.file_id,
                            file.file_name
                          )
                        }
                        style={{ color: "#1890FF" }}
                      >
                        {file.file_name}
                      </span>
                    </div>
                    <AiOutlineDelete
                      className="text-red-500 ml-2 bg-[rgba(0,115,199,0.07);]"
                      onClick={() =>
                        handleRemoveFileFromDocumentList(file.file_id)
                      }
                    />
                  </li>
                ))}
              </ul>
            )}
            {fileList.length !== 0 && (
              <ul
                style={{
                  margin: "10px 0 0",
                  paddingLeft: "0 !important",
                  height: " auto !important",
                  overflow: "hidden !important",
                }}
              >
                {fileList.map((file, index) => (
                  <li
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: "8px",
                      transition: "all ease 0.3s",
                      padding: "3px 0",
                      borderBottom: " 1px solid #ebebeb",
                      color: "#2C65AC",
                    }}
                    key={file.uid}
                  >
                    <div className="flex items-center">
                      <AiOutlineFolder className="mr-1 ml-1" />
                      <span style={{ color: "#1890FF" }}>{file.name}</span>
                    </div>
                    <div className="flex items-center">
                      <Button
                        className="text-[#1890FF]"
                        onClick={() => {
                          setIsRenameFileUpdate(true);
                          handleOpenPopupRenameFile(file, index);
                        }}
                      >
                        Đổi tên
                      </Button>
                      <AiOutlineDelete
                        className="text-red-500 ml-2 bg-[rgba(0,115,199,0.07);]"
                        onClick={() => handleRemoveFileFromUploadList(file.uid)}
                      />
                    </div>
                  </li>
                ))}
              </ul>
            )}

            <Box sx={{ display: "flex", marginTop: "20px" }}>
              <InputLabel style={{ color: "#23374D" }}>
                Người theo dõi :
              </InputLabel>
              <div>
                <Button
                  style={{
                    color: "#ffb100",
                    marginLeft: "5px",
                    marginTop: "-5px",
                    border: "1px solid blue",
                    marginBottom: "5px",
                  }}
                  onClick={() => handleOpenSelectUser(ASSIGNEE_TYPE.FOLLOWER)}
                >
                  <AiOutlineUser />
                </Button>
              </div>
            </Box>
            <div className="my-2">
              {followerList.length > 0 && (
                <SelectList>
                  {followerList.map((el) => (
                    <Tag
                      className={"tag-selected"}
                      color={"blue"}
                      key={el.id}
                      closable
                      onClose={() => selectPeopleStore.handleRemoveSelect(el)}
                    >
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={
                          (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <BankOutlined />
                          )) ||
                          (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                            <TeamOutlined />
                          ))
                        }
                      />
                    </Tag>
                  ))}
                </SelectList>
              )}
            </div>
          </>
        </DialogContent>
        <DialogActions
          sx={{ backgroundColor: "#e3e4e9", position: "sticky", bottom: "0" }}
        >
          <Button
            onClick={close}
            className="w-[94px] h-[40px] text-sm font-bold leading-5 text-primary"
          >
            Đóng
          </Button>
          <button
            type="submit"
            className="uppercase font-bold px-4 h-[40px] rounded-full text-sm leading-5 text-white bg-[#0073C7]"
          >
            Đồng ý chỉnh sửa
          </button>
        </DialogActions>
      </form>
      <SelectPeoplePopup
        disableSelectDepartment
        onlyOneUser={checkFollower}
        handleCancelSelectUser={handleSubmitSelectUser}
        handleSubmitSelectUser={handleSubmitSelectUser}
        isVisibleSelectPeoplePopup={isVisibleSelectUserPopup}
      />
      <Message
        message={messages}
        openMessage={openMessage}
        severity={severity}
        closeMessage={() => {
          setOpenMessage(false);
        }}
      />
      <PopupRenameFile
        isModalVisibleRenameFile={isModalVisibleRenameFile}
        handleCloseModalRenameFile={() => setIsModalVisibleRenameFile(false)}
        submitRenameFile={submitRenameFile}
        fieldsRenameFile={fieldsRenameFile}
        fileExt={fileExt}
      />
    </Dialog>
  );
};

export default inject(
  "workStore",
  "loadingAnimationStore",
  "fileStore",
  "selectPeopleStore",
  "proposalStore",
  "authenticationStore"
)(observer(UpdateProposal));
